import { ServiceHelper } from '../../src/app/services/servicehelper';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {
  Component,
  HostBinding,
  ViewEncapsulation,
  ViewChild,
  AfterViewInit,
  OnInit,
  NgZone,
  ChangeDetectorRef
} from '@angular/core';

import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { filter } from 'rxjs/operators';
import { UserData } from './shared/models/user.model';
import {
  SohoPersonalizeDirective,
  SohoRenderLoopService,
  SohoApplicationMenuComponent,
  SohoBusyIndicatorDirective,
  SohoModalDialogService
} from 'ids-enterprise-ng';
import { ACEEnums, Constants } from './app.constants';
import { CapacityModelService } from './services/CapacityModel-Service';
import { arePayCurvesEnabled } from './services/fiscal-year.helper';

@Component({
  selector: 'body',
  templateUrl: 'app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [ServiceHelper]
})
export class AppComponent implements OnInit {
  // @HostBinding('class.no-scroll') get isNoScroll() { return true; }
  // useUpliftIcons = true;
  // menuItems: any;
  // AppHeader: string = 'Customer 360';
  // mail: string = "";
  // isPartner: boolean = false;

  private static IS_APPLICATION_MENU_OPEN_KEY = 'is-application-menu-open';
  userData = new UserData();
  IsAdmin!: number;
  RoleName: string = "";
  public AppAccess: any = false;
  AccessControllerItems:any | undefined;//added
  //menuItems: any;
  showMenu: boolean = true;
  // Feature flag (per-environment) that controls whether the account
  // management (Access Controller / Edit Access) area is available.
  public readonly accountManagementEnabled: boolean = environment.featureFlags?.accountManagementEnabled ?? false;
  // True only for fiscal years from environment.payCurveMinFiscalYear (CY27)
  // onwards. Gates the Mapping Configuration menu group. Safe to evaluate once
  // here because changing the FY dropdown reloads the application.
  public readonly payCurvesEnabled: boolean = arePayCurvesEnabled();
  FilteredMenuItems: any | undefined;
  isInGetRoles: boolean = false;
  FilteredMenuManualItems: any | undefined;
  @ViewChild(SohoApplicationMenuComponent, { static: true })
  public applicationMenu!: SohoApplicationMenuComponent;

  @ViewChild(SohoPersonalizeDirective, { static: true }) personalize?: SohoPersonalizeDirective;

  @HostBinding('class.no-scroll') get isNoScroll() { return true; }
  @ViewChild(SohoBusyIndicatorDirective, { static: true }) busyIndicator?: SohoBusyIndicatorDirective;
  
  public useUpliftIcons = true;

  public personalizeOptions: SohoPersonalizeOptions = {};
  public menuItems: any = [
    {
      "Key": "Finance Activities",
      "Value": [
        //{
        //  "AppName": ACEEnums.TerritoryBudgets,
        //  "MenuItem": "Territory Budget",
        //  "AppHeader": "Territory Budget"
        //},
        {
          "AppName": ACEEnums.DetailedUpload,
          "MenuItem": "Participant Quota review",
          "AppHeader": "Participant Quota review"
        },
        {
          "AppName": ACEEnums.FinalQuotaList,
          "MenuItem": "Quota Submission",
          "AppHeader": "Quota Submission"
        },
        {
          "AppName": ACEEnums.QuotaInput,
          "MenuItem": "Quota Approval Request",
          "AppHeader": "Quota Approval Request"
        }
      ]
    },
    {
      "Key": "GIC Activities",
      "Value": [
        {
          "AppName": ACEEnums.QuotaInputGic,
          "MenuItem": "Quotas For Plan Generation",
          "AppHeader": "Quotas For Plan Generation"
        }
      ]
    },
    {
      "Key": "Upload",
      "Value": [
        {
          "AppName": ACEEnums.Upload,
          "MenuItem": "Upload Data",
          "AppHeader": "Upload Data"
        },
        {
          "AppName": ACEEnums.UploadRequests,
          "MenuItem": "Upload Requests",
          "AppHeader": "Upload Requests"
        }
      ]
    },
    {
      "Key": "Download Template",
      "Value": [
        {
          "AppName": ACEEnums.DownloadTemplate,
          "MenuItem": "Download Template",
          "AppHeader": "Download Template"
        }
      ]
    },


  ];
  public menuItemsManual:any = [
    {
      "Key": "GIC Manual Activities",
      "Value": [
        {
          "AppName": ACEEnums.QuotaInputManualGic,
          "MenuItem": "Quotas For Plan Generation",
          "AppHeader": "Quotas For Plan Generation"
        },
        {
          "AppName": ACEEnums.ArchivefileList,
          "MenuItem": "Archive File List",
          "AppHeader": "Archive File List"
        }
      ]
    },
    {
      "Key": "Upload",
      "Value": [
        {
          "AppName": ACEEnums.UploadManual,
          "MenuItem": "Upload Data",
          "AppHeader": "Upload Data"
        },
        {
          "AppName": ACEEnums.UploadManualRequests,
          "MenuItem": "Upload Requests",
          "AppHeader": "Upload Requests"
        }
      ]
    },
    {
      "Key": "Download Template",
      "Value": [
        {
          "AppName": ACEEnums.DownloadManualTemplate,
          "MenuItem": "Download Template",
          "AppHeader": "Download Template"
        },
      ]
    },
  ];
  public acessControllerItems:any = [
    {
      "Key": "Access Controller",
      "Value": [
        {
          "AppName": ACEEnums.AccessController,
          "MenuItem": "Create New User",
          "AppHeader": "Access Controller"
        },
        {
          "AppName": ACEEnums.EditAccess,
          "MenuItem": "Edit Access",
          "AppHeader": "Edit Access"

        }
      ]
    },
    {
      "Key": "Mapping Configuration",
      "Value": [
        {
          "AppName": ACEEnums.RolePlanTypeMapping,
          "MenuItem": "RoleType PlanType Mappings",
          "AppHeader": "RoleType PlanType Mappings"
        },
        {
          "AppName": ACEEnums.RolePayCurveMapping,
          "MenuItem": "RoleType PayCurve Mappings",
          "AppHeader": "RoleType PayCurve Mappings"
        }
      ]
    },
  ];



  constructor(private httpclient: HttpClient, public router: Router, private readonly renderLoop: SohoRenderLoopService,
    public service: ServiceHelper,
    private capacityModelService: CapacityModelService,
    private ngZone: NgZone,
    private modalDialog: SohoModalDialogService,
    private cdr: ChangeDetectorRef,private cookieService: CookieService) {
      
    this.userData = JSON.parse(localStorage.getItem("userprofile")!);
    if (this.userData != null && this.userData != undefined && this.userData.Email != '') {
      if (this.userData.SecurityroleDescription != undefined && this.userData.SecurityroleDescription != null && this.userData.SecurityroleDescription != "") {
        this.AppAccess = true;
        this.RoleName = this.userData.SecurityroleDescription;
      }
      else {
        this.AppAccess = false;
        this.RoleName = "";
      }
      this.loadMenu(false);
    }
  }
  ngOnInit() {
    this.start()
    this.router.events.pipe(filter((event: any) => event))
      .subscribe((data: any) => {
        console.log("Data URL is : " + data.url);
          if (data.url == "/access_token") {
          if (window.location.hash.search('#access_token') == 0) {
            let accessToken = location.hash.split('access_token=')[1].split('&')[0];
            // this.cookieService.set("ssotoken",accessToken, { expires: 1, path: '/', sameSite: 'None', secure: true });
            this.httpclient.get(environment.AADUserDetailsUrl, { headers: new HttpHeaders({ "Authorization": "Bearer " + accessToken }) })
              .subscribe((response: any) => {
                if (response.length == 0)
                  this.ngZone.run(() => this.router.navigate(["noaccess"])).then();
                else {
                // this.cookieService.set('ntLogin', response.onPremisesSamAccountName, { expires: 1, path: '/', sameSite: 'None', secure: true });
                // this.cookieService.set('userName', response.displayName, { expires: 1, path: '/', sameSite: 'None', secure: true });
                // this.cookieService.set('department', response.department, { expires: 1, path: '/', sameSite: 'None', secure: true });
                // this.cookieService.set('email', response.userPrincipalName, { expires: 1, path: '/', sameSite: 'None', secure: true });
                // this.cookieService.set('displayName', response.displayName, { expires: 1, path: '/', sameSite: 'None', secure: true });
                // this.cookieService.set('mail', response.mail?.toLowerCase(), { expires: 1, path: '/', sameSite: 'None', secure: true });
                // this.cookieService.set('employeeId', response.employeeId, { expires: 1, path: '/', sameSite: 'None', secure: true });
                let userdata = new UserData();
                userdata.AccessToken = accessToken;
                userdata.Name = response.displayName;
                userdata.Email = response.userPrincipalName;
                userdata.Title = response.jobTitle;
                userdata.NtLogin = response.onPremisesSamAccountName;
                userdata.Country = response.country;
                userdata.OfficeLocation = response.department;
                this.userData = userdata;
                localStorage.setItem("isInLogin", "false" )
                localStorage.setItem("userprofile", JSON.stringify(this.userData));
                this.getUserRoles();
                this.loadUserDetails();
                this.ngZone.run(() => this.router.navigate(["login"])).then();
                }
              })
          }
        }
        else {
          let test = '';
          this.userData = JSON.parse(localStorage.getItem("userprofile")!);
          if (this.userData != null && this.userData.Email != '') {
            if (this.userData.SecurityroleDescription != undefined && this.userData.SecurityroleDescription != null && this.userData.SecurityroleDescription != "") {
              this.stop();
              // this.AppAccess = true;
              // this.RoleName = this.userData.SecurityroleDescription;            
              // this.loadMenu(true);
            }
            else {
              this.getUserRoles();
              if( localStorage.getItem("isInGetRoles") == null || localStorage.getItem("isInGetRoles") == "false"){
                this.getUserRoles();
              }
              // this.AppAccess = false;
              // this.RoleName = "";
            }
            
          }
        }
      });
      const hasRefreshed = localStorage.getItem('hasRefreshed');
    if (!hasRefreshed) {
      setTimeout(() => {
        localStorage.setItem('hasRefreshed', 'true');
        this.refreshApplication();
      }, 5000);
    }
  }
  refreshApplication() {
    window.location.reload();
  }

  getUserRoles() {
    localStorage.setItem("isInGetRoles", "true" )
    this.capacityModelService.GetUserRole(this.userData.Email).subscribe(
      userDetails => {
        if (userDetails == null || userDetails == undefined) {
          this.userData.SecurityroleDescription = "";
          this.userData.SecurityroleID = "0";
          this.AppAccess = false;
          this.RoleName = "";
        }
        else {
          if (userDetails.securityroledescription == null || userDetails.securityroledescription == "") {
            this.userData.SecurityroleDescription = "";
            this.userData.SecurityroleID = "0";
            this.AppAccess = false;
            this.RoleName = "";
          }
          else {
            this.userData.SecurityroleDescription = userDetails.securityroledescription;
            this.userData.SecurityroleID = userDetails.securityroleid;
            this.AppAccess = true;
            this.RoleName = userDetails.securityroledescription;
            localStorage.setItem("isInGetRoles", "false" )
          }
        }
        localStorage.setItem("userprofile", JSON.stringify(this.userData));
        this.loadMenu(true)
        this.stop();
        //this.loadContent();
      },
      (error: Response) => {
        if(error.status == 401){
          this.router.navigate(["AccessDenied"]);
          this.stop();
          this.hidemenu(); 
        }
        this.AddErrorDetails(error);
      }
    );
    console.log("User Role fetched and came out at : " + new Date());
  }

  private loadUserDetails() {
    document.getElementById("lblEmployeeName")!.innerText = this.userData.Name;
    let img = <HTMLImageElement>document.getElementById("insn_userprofile_snap_img");

    var httpOptions = {
      headers: new HttpHeaders({ 'Authorization': "Bearer " + this.userData.AccessToken }),
      responseType: 'arraybuffer' as const,
    };
    this.httpclient.get(environment.AADUserImageUrl, httpOptions)
      .subscribe((response: any) => {
        var arrayBufferView = new Uint8Array(response);
        var blob = new Blob([arrayBufferView], { type: "image/jpeg" });
        var urlCreator = window.URL || window.webkitURL;
        var imageUrl = urlCreator.createObjectURL(blob);
        this.userData.Image = imageUrl;
        img.src = this.userData.Image;
        img.style.visibility = "visible";
        localStorage.setItem("userprofile", JSON.stringify(this.userData))
        //console.log(imageUrl);
      })
  }

  start() {
    (this.busyIndicator as any).activated = true;
  }
  stop() {
    (this.busyIndicator as any).activated = false;
  }
  showmenu(){
    this.showMenu = true;
  }
  hidemenu(){
    this.showMenu = false;
  }

  AddErrorDetails(error: Response) { }
  checkRole(role: string) {
    let test = role;
  }
  ngAfterViewInit(): void {
  }

  loadMenu(onSSO: boolean) {
    let rolename = this.RoleName;
    localStorage.setItem("rolename",rolename);
    if (this.RoleName == Constants.adminRole) {
      this.showmenu();
      this.FilteredMenuItems = JSON.parse(JSON.stringify(this.menuItems));
      this.FilteredMenuManualItems = JSON.parse(JSON.stringify(this.menuItemsManual));
      this.AccessControllerItems = this.accountManagementEnabled
        ? JSON.parse(JSON.stringify(this.acessControllerItems))
        : [];
    } else if(this.RoleName == Constants.financeRole) {
      this.showmenu();
      this.FilteredMenuItems = JSON.parse(JSON.stringify(this.menuItems));
      this.FilteredMenuItems = this.FilteredMenuItems.filter((item: { Key: string; }) => item.Key != Constants.GICActivities);
      this.FilteredMenuManualItems = JSON.parse(JSON.stringify(this.menuItemsManual));
      this.FilteredMenuManualItems = this.FilteredMenuManualItems.filter((item: { Key: string; }) => item.Key != Constants.GICManualActivities);
      this.AccessControllerItems = this.accountManagementEnabled
        ? JSON.parse(JSON.stringify(this.acessControllerItems))
        : [];
      this.AccessControllerItems = this.AccessControllerItems.filter((item:{Key:string;})=>item.Key!=Constants.AccessController);
    }
    // Mapping Configuration (RoleType PlanType / PayCurve mappings) is a
    // pay-curve-era area: hide the whole group for fiscal years before CY27.
    if (!this.payCurvesEnabled && this.AccessControllerItems) {
      this.AccessControllerItems = this.AccessControllerItems.filter((item: { Key: string; }) => item.Key != Constants.MappingConfiguration);
    }
    if (onSSO) {
      this.cdr.detectChanges();
    }
    this.applicationMenu?.updated();
  }
  public get isApplicationMenuOpen(): boolean {
    const valueString = localStorage.getItem(AppComponent.IS_APPLICATION_MENU_OPEN_KEY);
    return valueString ? (valueString === 'true') : true;
  }

  public set isApplicationMenuOpen(open: boolean) {
    localStorage.setItem(AppComponent.IS_APPLICATION_MENU_OPEN_KEY, open ? 'true' : 'false');
  }

  onChangeTheme(ev: SohoPersonalizeEvent) {
    this.useUpliftIcons = ev.data.theme === 'theme-uplift-light'
      || ev.data.theme === 'theme-uplift-dark'
      || ev.data.theme === 'theme-uplift-contrast';
  }

  public onMenuVisibility(visible: boolean): void {
    if (this.isApplicationMenuOpen !== visible) {
      this.isApplicationMenuOpen = visible;
    }
  }
}
